export function capitalize(str) {
    if (!str) {
        return "";
    }
    return str.charAt(0).toUpperCase() + str.slice(1)
}

export function hasLessThan(str, count) {
  return str.length < count;
}
